import type { FC } from 'react';
import { useCallback } from 'react';

import Button from '@trend-dev/trendtech-ui/components/UI/Button';

import { useYM } from 'YM/Context';
import { GoalType } from 'YM/declare';

import { preparationPageManager } from 'manager/preparationPageManager';

import { useRedirectTo } from 'hooks/useRedirectTo';

import { join } from '../../const';
import { usePreparationContext } from '../../Context';
import styles from './styles.module.scss';

const JoinButton: FC = () => {
    const redirectTo = useRedirectTo();
    const { isUserAllowedToEnterTheConference } = usePreparationContext();
    const { triggerYM } = useYM();

    const handleClick = useCallback(() => {
        preparationPageManager.setVisited();
        triggerYM({ goal: GoalType.PREPARATION_PAGE_JOIN });
        redirectTo();
    }, [redirectTo]);

    return (
        <div className={styles.wrapper}>
            <Button
                disabled={!isUserAllowedToEnterTheConference}
                className={styles.button}
                kind='main'
                size='md'
                borderRadius='md'
                onClick={handleClick}
            >
                {join}
            </Button>
        </div>
    );
};

export default JoinButton;
